import { Model } from 'libx'
import { observable, computed } from 'mobx'
import { extractProfileName } from 'utils/auth0Util'
import last from 'lodash/last'
import { generateAvatarFallback } from 'utils/dummyImageUtil'

/* eslint-disable camelcase */
export default class User extends Model {
  @observable name
  @observable picture
  @observable email

  @computed get firstName () {
    if (this.user_metadata.given_name) {
      return this.user_metadata.given_name
    }

    if (this.given_name) {
      return this.given_name
    }

    if (this.name === this.email) {
      return ''
    }

    return this.name ? this.name.split(' ')[0] : ''
  }

  @computed get lastName () {
    if (this.user_metadata.family_name) {
      return this.user_metadata.family_name
    }

    if (this.family_name) {
      return this.family_name
    }

    if (this.name === this.email) {
      return ''
    }

    return this.name ? last(this.name.split(' ')) : ''
  }

  @computed get displayName () {
    return `${this.firstName || ''} ${this.lastName || ''}`.trim() || this.name
  }

  @computed get avatar () {
    return this.user_metadata.picture || this.picture || this.avatarFallback
  }

  @computed get avatarFallback () {
    return generateAvatarFallback(this.displayName || this.email)
  }

  parse (json) {
    const { user_id, app_metadata = {}, email, user_metadata = {}, ...rest } = json
    return {
      ...rest,
      id: user_id,
      name: extractProfileName(json) || this.name,
      given_name: json.given_name || json.first_name,
      family_name: json.family_name || json.last_name,
      email: user_metadata.email_address || (this.user_metadata && this.user_metadata.email_address) || email || this.email,
      app_metadata: {
        ...this.app_metadata,
        ...app_metadata
      },
      user_metadata: {
        ...this.user_metadata,
        ...user_metadata
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/client/domain/User.js